import { render, staticRenderFns } from "./DocumentArchiveIndex.vue?vue&type=template&id=30590615&scoped=true&"
import script from "./DocumentArchiveIndex.vue?vue&type=script&lang=js&"
export * from "./DocumentArchiveIndex.vue?vue&type=script&lang=js&"
import style0 from "./DocumentArchiveIndex.vue?vue&type=style&index=0&id=30590615&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30590615",
  null
  
)

export default component.exports